import { render, staticRenderFns } from "./PinDraftDetail.vue?vue&type=template&id=78277688&scoped=true&"
import script from "./PinDraftDetail.vue?vue&type=script&lang=js&"
export * from "./PinDraftDetail.vue?vue&type=script&lang=js&"
import style0 from "./PinDraftDetail.vue?vue&type=style&index=0&id=78277688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78277688",
  null
  
)

export default component.exports